import { createFileRoute } from "@tanstack/react-router";
import { FolderTreeIcon } from "lucide-react";

export const Route = createFileRoute("/admin/subjects/$subjectId/structure")({
  component: Structure,
});

function Structure() {
  const { subjectId } = Route.useParams();
  return (
    <div>
      <div className="label-card">Structure</div>
      <h1 className="mt-1 font-display text-3xl font-semibold flex items-center gap-2">
        <FolderTreeIcon className="h-6 w-6 text-paprika" />
        Folder tree
      </h1>
      <p className="mt-2 text-ink-soft">
        Manage modules and nested folders for subject{" "}
        <span className="font-mono text-sm">{subjectId}</span>.
      </p>
      <div className="mt-8 card-ledger p-8 text-center text-ink-soft">
        Tree editor with drag-to-reorder + rename mounts here once{" "}
        <code className="font-mono text-xs">/directories</code> CRUD is available.
      </div>
    </div>
  );
}
